/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AutomaticPauseTemplate } from '../../models/automatic-pause-template';
import { AutomaticPauseTemplateUpdateRequest } from '../../models/automatic-pause-template-update-request';

export interface UpdateAutomaticPauseTemplate$Params {
  'Active-Tenant-Identifier': string;
  templateId: string;
      body: AutomaticPauseTemplateUpdateRequest
}

export function updateAutomaticPauseTemplate(http: HttpClient, rootUrl: string, params: UpdateAutomaticPauseTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<AutomaticPauseTemplate>> {
  const rb = new RequestBuilder(rootUrl, updateAutomaticPauseTemplate.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('templateId', params.templateId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AutomaticPauseTemplate>;
    })
  );
}

updateAutomaticPauseTemplate.PATH = '/ordering/automatic-pause-templates/{templateId}';
